// Mock data for Nasu Agency clone

export const navData = {
  brand: 'Nasu Group',
  groups: [
    {
      label: 'Nasu Management',
      items: [
        { label: 'About', href: '/about' },
        { label: 'What We Offer', href: '/what-we-offer' }
      ]
    },
    {
      label: 'Nasu Agency',
      items: [
        { label: 'Services', href: '/services' },
        { label: 'Our Work', href: '/work' },
        { label: 'Blog', href: '/blog' }
      ]
    }
  ],
  cta: { label: 'Book a strategy session', href: '/contact' }
};

export const heroImages = [
  '/hero-images/hero-1.png',
  '/hero-images/hero-2.png',
  '/hero-images/hero-4.png',
  '/hero-images/hero-3.png'
];

export const brandLogos = [
  { name: 'Riyadh Season', src: '/brand-logos/riyadh-season.svg' },
  { name: 'Nohrlund', src: '/brand-logos/nohrlund.png' },
  { name: '2K Games', src: '/brand-logos/2k.png' },
  { name: 'GEA', src: '/brand-logos/gea.svg', className: 'h-10 md:h-11' },
  { name: 'Birds Eye', src: '/brand-logos/birds-eye.png' },
  { name: 'Suntory', src: '/brand-logos/suntory.svg', className: 'h-9 md:h-10' }
];

export const services = [
  {
    id: 'creator-360',
    title: 'Creator 360',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1200&q=80',
    body: 'Capitalise on the power of authentic human connections. People are more likely to buy when they hear from the creators they already trust and follow. We deliver end-to-end management of social-first marketing using exclusive data from globally recognised creators \u2014 generating brand awareness, conversions and even advocacy.',
    detail: [
      'Capture attention in a loud space through full-funnel social strategies, powered by creators. Whatever your goal \u2014 from brand awareness to revenue growth \u2014 Nasu Group is the all-in-one social powerhouse to get you there. We launch campaigns with some of the world\u2019s most influential creators.',
      'This gives us real-time learnings to shape our strategies, avoid inflated fees, and keep your brand ahead of the competition. From one-off launches to long-term retainers, creators are your in-way to culture, helping you build authentic, lasting connections with your audience.'
    ]
  },
  {
    id: 'community-seeding',
    title: 'Community Seeding',
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1200&q=80',
    body: 'More than just gifting, this is your ticket to connect to storytellers in your niche \u2014 at scale. We strategically seed your product to fans of your brand, targeting nano creators with highly engaged audiences. The outcome: Guaranteed UGC and social media\u2019s most trusted peer-to-peer recommendations.',
    detail: [
      'Insert your brand naturally into the conversation and stay relevant. We strategically seed your product to fans of your brand, targeting nano creators with engaged audiences.',
      'Community seeding has fast become the go-to strategy for UGC and social\u2019s most trusted peer-to-peer recommendations. We nurture your brand\u2019s growth consistently and organically by connecting with storytellers in your niche. Every interaction is authentic. Every touchpoint is valuable.'
    ]
  },
  {
    id: 'paid-media',
    title: 'Paid Media',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&q=80',
    body: 'Capitalise on high-performance social content. We amplify your creator campaigns using paid spend to build awareness and drive action. Your content has never worked so hard. And your ROI has never looked so good.',
    detail: [
      'Stop throwing money at paid media that doesn\u2019t perform. Get in on the secret everyone else seems to know: Paid media is game-changing. At Nasu Group, we manage your budget to amplify high-performing content.',
      'That starts with a fractional budget to test bidding strategies, content and targeting for a pulse check before ramping things up. It ends with hitting your goals, whether that be awareness or conversions.'
    ]
  },
  {
    id: 'social-media-management',
    title: 'Social Media Management',
    image: 'https://images.unsplash.com/photo-1432888622747-4eb9a8f2c293?w=1200&q=80',
    body: 'Best-in-class videographers, editors, strategists, graphic designers and community managers aren\u2019t always in the budget. So, swap in-house hires for a social-first agency and plug a whole team of experts into your strategy.',
    detail: [
      'Tried social media marketing and got the scars to prove it? You just haven\u2019t found your people yet. We can take over full management of your socials, including strategy, content creation, community engagement, and reporting. This is the cost-effective way to plug the gaps in your in-house resources.',
      'We believe in data-led strategies over vanity metrics. Proaction over letting the competition lead. We analyse past campaigns to help us hit your goals, turning social into one of your biggest revenue drivers. Finally unlock the capacity to put your ideas into action, and see what happens when data and creative come together. We\u2019re talking revenue, not just likes.'
    ]
  },
  {
    id: 'content-production',
    title: 'Content Production',
    image: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=1200&q=80',
    body: 'From HIFI YouTube clips to snappy LOFI TikToks, get platform-specific social content that keeps you top-of-mind for your audience. From ideation to production and post-production, we cover all bases, with the consistency you need to grow your brand.',
    detail: [
      'Creating high-quality content that resonates isn\u2019t as simple as it sounds. Ideas can fall flat without the right talent, time and equipment. But we\u2019ve found the winning formula, so leave it to us. We usually focus on long-form YouTube videos that we can cut down into platform-specific clips that perform.',
      'Partner with Nasu Group for content that keeps up with the speed of social. Let your competitors wonder why you\u2019re the brand everyone\u2019s talking about.'
    ]
  }
];

export const work = [
  {
    id: 'coop-live-nation',
    category: 'Food & Drink',
    title: 'The Co-op x Live Nation',
    subtitle: 'Co-op x Live Nation: Amplifying Festival Fun and Membership Sign-ups',
    image: 'https://images.unsplash.com/photo-1493676304819-0d7a8d026dcf?w=1400&q=80',
    description: 'To drive membership sign-ups and elevate Co-op\u2019s presence at festivals, we partnered with Live Nation to create a compelling three-stage content journey, all while highlighting Co-op\u2019s convenient services, membership perks, and delivery options.',
    metrics: [
      { value: '43.2K', label: 'Impressions' },
      { value: '283', label: 'Engagements' },
      { value: '0.64%', label: 'ER Rate' }
    ]
  },
  {
    id: 'birds-eye',
    category: 'Food & Drink',
    title: 'Birds Eye Fast Start',
    subtitle: 'Birds Eye: Celebrating 100 Years of Fast Freezing',
    image: 'https://images.unsplash.com/photo-1606787366850-de6330128bfc?w=1400&q=80',
    description: "Birds Eye's '100 Years of Fast Freezing' campaign leveraged micro-influencers to promote special offers across three major retailers, achieving increased engagement and reaching niche audiences through targeted content on Instagram and TikTok.",
    metrics: [
      { value: '1.2M', label: 'Views' },
      { value: '34K', label: 'Engagements' },
      { value: '4.8%', label: 'ER Rate' }
    ]
  },
  {
    id: 'aldi-easter',
    category: 'Food & Drink',
    title: 'Aldi Easter',
    subtitle: 'Aldi\u2019s Easter Campaign: Celebrate Your Way with Aldi',
    image: 'https://images.unsplash.com/photo-1490818387583-1baba5e638af?w=1400&q=80',
    description: 'We collaborated with Aldi to promote their Easter range and invite shoppers to \u201ccelebrate Easter their way\u201d. The campaign aimed to place Aldi\u2019s new Easter range at the heart of the conversation, highlighting its variety and quality to support shoppers\u2019 celebrations.',
    metrics: [
      { value: '232K', label: 'Views' },
      { value: '9.2K', label: 'Engagements' },
      { value: '5.20%', label: 'ER Rate' }
    ]
  },
  {
    id: 'nohrlund-live-nation',
    category: 'Food & Drink',
    title: 'Nohrlund x Live Nation',
    subtitle: 'Nohrlund x Live Nation: Amplifying Festival Fun with Organic Cocktails',
    image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=1400&q=80',
    description: 'We partnered with organic cocktail brand Nohrlund to create a dynamic campaign that highlighted the brand at key Both UK and USA festivals \u2014 Download and Isle of Wight. The aim was to amplify brand awareness while engaging festival-goers through authentic, creator-driven content.',
    metrics: [
      { value: '4.7M', label: 'Views' },
      { value: '21.5K', label: 'Engagements' },
      { value: '29%', label: 'ER Rate' }
    ]
  },
  {
    id: 'topspin',
    category: 'Sports & Fitness',
    title: 'TopSpin 2K25',
    subtitle: "2K\u2019s TopSpin 2K25: Building Anticipation for a Grand Slam Release",
    image: 'https://images.unsplash.com/photo-1622279457486-62dcc4a431d6?w=1400&q=80',
    description: 'We collaborated with 2K Games to generate excitement and awareness for the launch of TopSpin 2K25. The goal of the campaign was to leverage creator partnerships to showcase in-game experiences and brand collaborations, creating buzz around the upcoming game.',
    metrics: [
      { value: '12.5M', label: 'Views' },
      { value: '105K', label: 'Engagements' },
      { value: '8.0%', label: 'ER Rate' }
    ]
  },
  {
    id: 'aldi-team-gb',
    category: 'Sports & Fitness',
    title: 'Aldi Team GB',
    subtitle: 'Aldi X Team GB: A Winning Partnership at the Paris 2024 Olympics',
    image: 'https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=1400&q=80',
    description: "We collaborated with Aldi to promote their ongoing partnership with Team GB at the Paris 2024 Olympics. The campaign focused on generating excitement around Aldi's involvement in the Games by tapping into creator-driven content.",
    metrics: [
      { value: '4.1M', label: 'Views' },
      { value: '64.2K', label: 'Engagements' },
      { value: '6.20%', label: 'ER Rate' }
    ]
  }
];

export const faqs = [
  {
    q: 'What does an influencer marketing agency do?',
    a: 'An influencer marketing agency connects brands with trusted creators, managing campaigns end-to-end (strategy, talent sourcing, content creation, execution and reporting) to deliver authentic, data-driven results across social platforms.'
  },
  {
    q: 'Why should I hire an influencer marketing agency?',
    a: 'Hiring an influencer marketing agency saves time, ensures authentic creator partnerships, maximises ROI, and leverages expert data insights to deliver scroll-stopping campaigns that grow audiences and drive measurable brand impact.'
  },
  {
    q: 'How do you choose the right influencers for a campaign?',
    a: 'We carefully match influencers using exclusive data on audience demographics, engagement, and niche relevance, ensuring authentic collaborations that resonate with target audiences and deliver maximum impact for brand goals.'
  },
  {
    q: 'Which platforms does your influencer marketing agency specialise in?',
    a: 'We specialise in social-first platforms like TikTok, Instagram, YouTube, and more, crafting tailored campaigns that meet audiences where they spend time, driving visibility, engagement, and conversions for every brand partnership.'
  },
  {
    q: 'Can an influencer marketing agency support both B2B and B2C brands?',
    a: 'Absolutely. From consumer-facing brands to B2B organisations, we design social-first campaigns that leverage trusted creator voices, boosting awareness, credibility, and lead generation across both consumer and professional audiences.'
  },
  {
    q: 'How do you measure the success of an influencer marketing campaign?',
    a: 'We track engagement, reach, conversions, and ROI, backed by data-driven reporting. Alongside metrics, we also measure community growth, authentic connections, and long-term audience impact to ensure real campaign success.'
  },
  {
    q: 'How much does it cost to work with an influencer marketing agency?',
    a: 'Costs depend on campaign size, platforms, and creators involved. We build transparent, tailored packages to match your budget, ensuring scalable influencer campaigns that deliver genuine value and measurable results.'
  },
  {
    q: 'How do I get started with your influencer marketing agency?',
    a: 'Contact our team to discuss your goals. We\u2019ll align you with the right creators, build a strategy, and launch your campaign. End-to-end support is included from day one.'
  }
];

export const blogPosts = [
  {
    id: 'finance-influencers',
    category: 'Creator Economy',
    readTime: '5 mins read',
    title: 'Defining Finance Influencers: Who They Are & What They Create',
    excerpt: 'Who are finance influencers, and what content are they creating?',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&q=80',
    publishedAt: 'January 12, 2026',
    author: 'Nasu Strategy Team',
    intro:
      'Finance creators are no longer a niche footnote on social. They are translators, commentators, myth-busters, and sometimes the first place younger audiences go when they want to understand money without being talked down to.',
    story: [
      {
        heading: 'The shift started with trust, not trends',
        paragraphs: [
          'For years, financial advice online was either overly technical or painfully generic. Then creators stepped into the gap. They filmed budget breakdowns at kitchen tables, explained investing with screen recordings, and turned intimidating money language into something human.',
          'The most effective finance influencers did not begin by acting like institutions. They began by telling the truth about lived experience: first pay checks, debt anxiety, side hustles, tax confusion, and the slow process of building security.'
        ]
      },
      {
        heading: 'A finance creator is really a storyteller with receipts',
        paragraphs: [
          'What separates strong finance creators from surface-level commentators is specificity. They show the spreadsheet, the trade-off, the mistake, and the lesson. Audiences respond because they can see the stakes, not just the outcome.',
          'That content might look like weekly market explainers, practical saving challenges, salary transparency, debt diaries, or honest reflections on risk. The common thread is usefulness wrapped in personal context.'
        ]
      },
      {
        heading: 'Why brands should pay attention',
        paragraphs: [
          'Finance creators influence more than app downloads. They shape behavior. When they recommend a product, audiences expect clarity on fees, safety, and actual value, which raises the bar for every partnership.',
          'For brands, that means the opportunity is not to borrow credibility with flashy campaigns. It is to earn it by helping creators make genuinely educational, transparent content that respects the audience.'
        ]
      }
    ]
  },
  {
    id: '2026-predictions',
    category: 'Creator Economy',
    readTime: '5 mins read',
    title: '2026 Creator & Marketing Predictions',
    excerpt: 'Get predictions and insights to shape your marketing strategy.',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&q=80',
    publishedAt: 'January 28, 2026',
    author: 'Nasu Insights',
    intro:
      'Every new year brings loud predictions, but the most useful ones come from patterns already visible in how creators work, how platforms reward attention, and how audiences decide what feels worth their time.',
    story: [
      {
        heading: 'Prediction one: brands will buy consistency before they buy reach',
        paragraphs: [
          'The era of one-off viral ambition is cooling. Marketing teams are under pressure to show how creator work compounds over time, which means repeat partnerships, series-based formats, and creators who can hold attention across months instead of moments.',
          'This is not less creative. It is more disciplined. The strongest campaigns will feel like chapters, not stunts.'
        ]
      },
      {
        heading: 'Prediction two: audience quality will matter more than audience size',
        paragraphs: [
          'Teams are getting sharper about the difference between visible popularity and commercial influence. A creator with a smaller but highly responsive community is often a better strategic bet than a much larger account with soft engagement.',
          'That will push more briefs toward niche expertise, stronger creative fit, and clearer measurement expectations from the start.'
        ]
      },
      {
        heading: 'Prediction three: long-form will quietly power short-form wins',
        paragraphs: [
          'Short-form is still the discovery engine, but long-form is where loyalty deepens. The creators who win in 2026 will increasingly treat short clips as trailers for richer worlds on YouTube, newsletters, podcasts, and community spaces.',
          'Brands that understand this will stop briefing for a single asset and start building systems that let one insight travel across multiple formats.'
        ]
      }
    ]
  },
  {
    id: 'tiktok-trends',
    category: 'YouTube',
    readTime: '4 mins read',
    title: 'TikTok Trends That Will Shape The Year Ahead',
    excerpt: 'A breakdown of the formats and creators leading the algorithm.',
    image: 'https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?w=1200&q=80',
    publishedAt: 'February 9, 2026',
    author: 'Nasu Social Desk',
    intro:
      'TikTok trends rarely matter because they are trendy. They matter when they reveal how culture is moving: what people want to imitate, remix, confess, parody, or pass on to friends before the moment expires.',
    story: [
      {
        heading: 'Trend cycles are getting shorter, but audience memory is getting stronger',
        paragraphs: [
          'Creators can no longer rely on copying a format three weeks late and hoping the algorithm will be generous. Audiences are quicker to spot imitation without perspective.',
          'The creators still breaking through use trends as a framing device, not a script. They know the meme, but they also add a point of view, a niche angle, or a reveal that makes the content feel earned.'
        ]
      },
      {
        heading: 'Educational entertainment keeps outperforming empty spectacle',
        paragraphs: [
          'One of the clearest signals on the platform is the rise of useful content that still feels playful. Tutorials, explainers, reaction-led commentary, and day-in-the-life storytelling continue to spread because they satisfy curiosity and emotion at the same time.',
          'That is why trend participation works best when the creator has something real to say, not just something recognizable to repeat.'
        ]
      },
      {
        heading: 'The smart play for brands is creative adjacency',
        paragraphs: [
          'Brands do not need to impersonate creators to join a trend well. They need to understand the rhythm of the format and collaborate with people who already know how their audience speaks.',
          'Creative adjacency means showing up with the right tone, a clear role in the joke or insight, and enough restraint not to flatten the thing people liked in the first place.'
        ]
      }
    ]
  },
  {
    id: 'protecting-creator-time',
    category: 'Creator Economy',
    readTime: '4 mins read',
    title: 'Protecting Creator Time: The Value of Influencer Management',
    excerpt: 'The right team saves you time and transforms how you work.',
    image: 'https://images.unsplash.com/photo-1531497865144-0464ef8fb9a9?w=1200&q=80',
    publishedAt: 'February 21, 2026',
    author: 'Nasu Talent Team',
    intro:
      'A creator’s most limited resource is not ideas. It is uninterrupted time. Once momentum is lost to inboxes, negotiation loops, scheduling friction, and admin sprawl, even brilliant talent starts operating in survival mode.',
    story: [
      {
        heading: 'The hidden cost of doing everything yourself',
        paragraphs: [
          'Early in a creator career, handling every task personally can feel empowering. It keeps control close. But as opportunities stack up, self-management often turns into fragmented attention.',
          'The problem is not just workload. It is context switching. Writing, filming, editing, reviewing contracts, chasing payments, and replying to five brand threads in one afternoon leaves very little room for creative depth.'
        ]
      },
      {
        heading: 'Management creates space, not dependency',
        paragraphs: [
          'Good management does not make a creator less involved. It makes them more intentional. The right team filters noise, protects boundaries, and builds a process that keeps the creator focused on the work only they can do.',
          'That might mean shaping deal flow, structuring approvals, negotiating timelines, or stepping in before a rushed brief damages the channel. Each action buys back attention and confidence.'
        ]
      },
      {
        heading: 'Protected time leads to better creative outcomes',
        paragraphs: [
          'When creators are not permanently behind, the quality of output changes. They experiment more, say yes more selectively, and create with a clearer sense of direction.',
          'Over time, that turns into stronger partnerships and a healthier career. Protecting creator time is not an operational nicety. It is a growth strategy.'
        ]
      }
    ]
  },
  {
    id: 'creator-burnout',
    category: 'Creator Advice',
    readTime: '4 mins read',
    title: 'Creator Burnout: Sustainable Growth Beyond Virality',
    excerpt: 'The pressure to stay relevant is a lot. This is how you manage it.',
    image: 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=1200&q=80',
    publishedAt: 'March 4, 2026',
    author: 'Nasu Creator Care',
    intro:
      'Burnout in the creator economy rarely arrives with a dramatic announcement. More often, it shows up as dullness: slower ideas, heavier posting days, and the creeping belief that rest is the same thing as falling behind.',
    story: [
      {
        heading: 'Virality teaches the wrong lesson if you let it',
        paragraphs: [
          'A breakout moment can be energizing, but it can also distort expectations. Once a creator has one spike, every future post can start to feel like a test of whether they still matter.',
          'That is where burnout begins. Not from effort alone, but from attaching self-worth to unstable metrics.'
        ]
      },
      {
        heading: 'Sustainable creators build rhythms, not just results',
        paragraphs: [
          'The people who last tend to design their output around repeatable systems. They know what kind of content gives them energy, what support they need, and when they are producing from conviction instead of panic.',
          'This can look surprisingly simple: batching ideas, protecting offline time, defining non-negotiable boundaries, and refusing opportunities that pay well but erode the brand.'
        ]
      },
      {
        heading: 'Growth is stronger when it leaves room for a real life',
        paragraphs: [
          'Audiences connect with creators who feel present, not depleted. A sustainable pace is not a compromise on ambition. It is often what allows ambition to mature into something resilient.',
          'The goal is not to post less at all costs. It is to build a career that still feels livable when the metrics dip, the platform changes, or life asks more of you.'
        ]
      }
    ]
  },
  {
    id: 'foundations-creator-success',
    category: 'Creator Advice',
    readTime: '5 mins read',
    title: 'Building Strong Foundations For Creator Success: Why You Need Talent Management',
    excerpt: 'If you\u2019re asking, "do I need a talent manager?", this is for you.',
    image: 'https://images.unsplash.com/photo-1573497019418-b400bb3ab074?w=1200&q=80',
    publishedAt: 'March 18, 2026',
    author: 'Nasu Management',
    intro:
      'Most creator careers do not stall because the talent is missing. They stall because the foundations underneath the talent were never built to support growth once the opportunities become real.',
    story: [
      {
        heading: 'Success becomes fragile without structure',
        paragraphs: [
          'A sudden run of brand interest can feel like proof that everything is working. But momentum without structure often leads to missed emails, inconsistent pricing, unclear boundaries, and content decisions made too quickly.',
          'Talent management adds architecture to that growth. It creates repeatable systems for commercial work, creative planning, and long-term positioning.'
        ]
      },
      {
        heading: 'Managers see the career, not just the campaign',
        paragraphs: [
          'A strong manager is not only there to close deals. They help connect the dots between where a creator is now and what they are actually building over the next two or three years.',
          'That perspective matters when choosing partnerships, shaping new formats, and deciding when to say no to something that looks attractive in the short term but weakens the bigger picture.'
        ]
      },
      {
        heading: 'The right support makes ambition easier to sustain',
        paragraphs: [
          'When creators know the operational side is cared for, they work with more confidence. They can think bigger because they are not constantly patching holes in the process.',
          'Good management does not replace hustle. It gives hustle somewhere stable to land.'
        ]
      }
    ]
  },
  {
    id: 'vr-influencers',
    category: 'Creator Economy',
    readTime: '5 mins read',
    title: 'Virtual Reality Influencers: The Future Of Experiential Marketing',
    excerpt: 'The future of experiential marketing has arrived: VR influencers.',
    image: 'https://images.unsplash.com/photo-1592478411213-6153e4ebc07d?w=1200&q=80',
    publishedAt: 'April 2, 2026',
    author: 'Nasu Innovation Lab',
    intro:
      'Experiential marketing has always promised immersion. Virtual reality creators are finally making that promise feel practical by building worlds that audiences can explore, react to, and remember as more than a passive ad impression.',
    story: [
      {
        heading: 'VR creators are changing what participation looks like',
        paragraphs: [
          'Traditional campaigns often ask audiences to watch, like, and move on. VR creators invite them into a space. Whether that is a product demo, branded challenge, virtual venue, or interactive story, the user becomes part of the experience instead of a spectator at the edge of it.',
          'That shift changes how attention behaves. Time spent inside a well-designed environment carries a different emotional weight than a fast scroll-by.'
        ]
      },
      {
        heading: 'The real value is not novelty alone',
        paragraphs: [
          'If VR is used only because it feels futuristic, the work ages quickly. The strongest campaigns begin with a clearer question: what can someone understand, feel, or do here that would be weaker in another format?',
          'Creators who answer that well are not just showing off a tool. They are designing memory.'
        ]
      },
      {
        heading: 'Brands need collaborators who understand immersion',
        paragraphs: [
          'Working in VR means briefing for movement, space, pacing, and interaction, not just visuals. The creator becomes part director, part host, part experience designer.',
          'That is why partnerships in this space work best when brands let creators shape the journey instead of forcing conventional ad logic into a new environment.'
        ]
      }
    ]
  },
  {
    id: 'personal-branding',
    category: 'Personal Branding',
    readTime: '6 mins read',
    title: 'Personal Branding 101: Standing Out In A Crowded Feed',
    excerpt: 'How to build a personal brand that customers and creators recognise.',
    image: 'https://images.unsplash.com/photo-1573164713988-8665fc963095?w=1200&q=80',
    publishedAt: 'April 14, 2026',
    author: 'Nasu Brand Studio',
    intro:
      'A personal brand is not a logo, a color palette, or a perfectly rehearsed elevator pitch. It is the pattern people remember after repeated contact with your work, your voice, and the way you make them feel.',
    story: [
      {
        heading: 'Recognition starts with clarity',
        paragraphs: [
          'In crowded feeds, vague identity disappears quickly. The creators and founders who stand out tend to be understood in a sentence: what they care about, who they speak to, and why their perspective is distinct.',
          'That clarity gives audiences a reason to return. It also makes creative decisions easier because not every trend or opportunity belongs to your brand.'
        ]
      },
      {
        heading: 'Consistency should feel coherent, not repetitive',
        paragraphs: [
          'People often confuse consistency with sameness. In practice, strong personal brands evolve all the time. What stays stable is the underlying point of view.',
          'You can experiment with new formats, topics, and collaborations without confusing your audience if the core voice remains recognizable.'
        ]
      },
      {
        heading: 'The strongest brands give people something to believe in',
        paragraphs: [
          'A memorable personal brand makes an implicit promise. Maybe it is honesty, humor, ambition, depth, or calm expertise. Whatever it is, the audience should be able to feel it repeatedly.',
          'That is what turns content into identity, and identity into long-term value.'
        ]
      }
    ]
  },
  {
    id: 'gen-zalpha',
    category: 'Gen Zalpha',
    readTime: '4 mins read',
    title: 'Marketing To Gen Zalpha: What Brands Need To Know',
    excerpt: 'Meet the next generation reshaping content and commerce.',
    image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=1200&q=80',
    publishedAt: 'April 26, 2026',
    author: 'Nasu Youth Culture Team',
    intro:
      'Gen Zalpha is often described as difficult to reach, but that is only true if a brand expects attention without earning relevance. This audience grew up inside content systems that train instinctive filtering.',
    story: [
      {
        heading: 'They are not anti-brand, they are anti-performance',
        paragraphs: [
          'Younger audiences do not reject marketing because it is marketing. They reject signals that feel scripted, patronizing, or culturally delayed.',
          'When a campaign lands, it is usually because the brand understood the language of the space without trying to wear it like a costume.'
        ]
      },
      {
        heading: 'Participation beats broadcasting',
        paragraphs: [
          'This generation expects interaction, remixability, and a reason to care beyond the sales message. The best creator-led work gives them a role, whether that is responding, co-creating, sharing identity markers, or using the product in a way that feels socially meaningful.',
          'That is why community-native creators matter so much here. They know how to invite people in instead of just speaking at them.'
        ]
      },
      {
        heading: 'Relevance comes from cultural listening',
        paragraphs: [
          'Brands often move too slowly to spot how quickly jokes, references, and anxieties evolve. Staying relevant with Gen Zalpha requires active listening, not one annual strategy deck.',
          'The brands that win are the ones willing to learn in public, adapt quickly, and collaborate with creators whose instincts are already trusted.'
        ]
      }
    ]
  },
  {
    id: 'community-engagement',
    category: 'Community & Engagement',
    readTime: '5 mins read',
    title: 'Beyond Followers: Building Real Community Around Your Brand',
    excerpt: 'Why community wins where reach falls short.',
    image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1200&q=80',
    publishedAt: 'May 3, 2026',
    author: 'Nasu Community Team',
    intro:
      'A large audience can create the appearance of momentum. Community creates the substance of it. The difference matters because reach can be rented, while belonging has to be built.',
    story: [
      {
        heading: 'Community begins where performance metrics stop',
        paragraphs: [
          'Follower counts, views, and impressions are useful signals, but they do not automatically tell you whether people care enough to return, respond, or advocate.',
          'Community shows up in the slower indicators: repeated participation, inside jokes, thoughtful replies, user-generated rituals, and people recommending you without being prompted.'
        ]
      },
      {
        heading: 'Brands earn loyalty by behaving like hosts',
        paragraphs: [
          'The best community builders understand that an audience is not an asset to mine. It is a space to maintain. That means listening carefully, rewarding contribution, and creating interactions that feel mutual.',
          'Even small gestures can shift the tone: responding well, spotlighting members, designing experiences for conversation, and making people feel seen beyond their wallet.'
        ]
      },
      {
        heading: 'Creators are often the bridge to real belonging',
        paragraphs: [
          'Creators know how to make large digital spaces feel personal. Their communities already run on familiarity, repetition, and trust, which is why they are so effective when a brand genuinely wants to build relationships instead of temporary noise.',
          'If the goal is durable attention, community is not the soft metric. It is the moat.'
        ]
      }
    ]
  },
  {
    id: 'youtube-shorts',
    category: 'YouTube',
    readTime: '3 mins read',
    title: 'YouTube Shorts Strategy: From Snackable To Subscribable',
    excerpt: 'Tactics to convert short-form viewers into long-form subs.',
    image: 'https://images.unsplash.com/photo-1611605698335-8b1569810432?w=1200&q=80',
    publishedAt: 'May 7, 2026',
    author: 'Nasu Video Strategy',
    intro:
      'YouTube Shorts are excellent at introducing a creator to new people. The real challenge is what happens next: can that quick hit of attention become a relationship strong enough to earn a subscription and, eventually, long-form watch time?',
    story: [
      {
        heading: 'Shorts work best when they point somewhere',
        paragraphs: [
          'A good Short can entertain in isolation, but a strategic Short also hints at a bigger world. It sparks enough curiosity that the viewer wants the fuller explanation, the longer story, or the next episode.',
          'That means the format should be designed as an entry point, not treated like a disconnected content side quest.'
        ]
      },
      {
        heading: 'Conversion depends on continuity',
        paragraphs: [
          'Channels often struggle when their Shorts personality feels unrelated to their long-form identity. Viewers arrive expecting one thing and find another.',
          'The strongest creators keep a consistent voice across formats. A Short may be faster and sharper, but it should still feel like a natural door into the main channel.'
        ]
      },
      {
        heading: 'Subscription is earned through payoff',
        paragraphs: [
          'People subscribe when they believe more good things are coming. Shorts can make that promise, but long-form content has to fulfill it.',
          'When the handoff is clear and the value compounds, snackable content becomes subscribable growth instead of disposable reach.'
        ]
      }
    ]
  },
  {
    id: 'personal-brand-creators',
    category: 'Personal Branding',
    readTime: '4 mins read',
    title: 'Why Every Creator Needs A Personal Brand Playbook',
    excerpt: 'A clear playbook is what separates hobbyists from full-time creators.',
    image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=1200&q=80',
    publishedAt: 'May 10, 2026',
    author: 'Nasu Growth Team',
    intro:
      'Creators often build their personal brand accidentally at first. A playbook is the moment that brand becomes deliberate: documented, directional, and useful when decisions get noisy.',
    story: [
      {
        heading: 'A playbook turns instinct into repeatable strategy',
        paragraphs: [
          'Most established creators already have patterns that work. They know which stories resonate, which visuals feel on-brand, and which opportunities tend to pay off. The issue is that this knowledge often lives in memory rather than in a usable system.',
          'A playbook captures those instincts so content, partnerships, and future collaborators all move in the same direction.'
        ]
      },
      {
        heading: 'It helps creators make faster, cleaner decisions',
        paragraphs: [
          'When a brief arrives, a playbook gives immediate criteria. Does this fit the audience? Does it match the creator’s tone? Does it support the bigger career direction?',
          'That clarity reduces hesitation and protects against saying yes to deals that create short-term revenue but long-term confusion.'
        ]
      },
      {
        heading: 'The goal is not rigidity, it is alignment',
        paragraphs: [
          'A strong playbook should leave room for surprise and evolution. It is there to keep the foundation intact while the creative expression grows.',
          'In that sense, a personal brand playbook is less about control and more about confidence. It helps creators scale without becoming generic.'
        ]
      }
    ]
  }
];

export const getBlogPostById = (id) => blogPosts.find((post) => post.id === id);

export const blogCategories = [
  'All',
  'Personal Branding',
  'Gen Zalpha',
  'Community & Engagement',
  'Creator Economy',
  'Creator Advice',
  'YouTube'
];

export const footerLinks = {
  management: {
    label: 'Nasu Management',
    items: [
      { label: 'About', href: '/about' },
      { label: 'What We Offer', href: '/what-we-offer' }
    ]
  },
  agency: {
    label: 'Nasu Agency',
    items: [
      { label: 'Services', href: '/services' },
      { label: 'Work', href: '/work' },
      { label: 'Blog', href: '/blog' }
    ]
  },
  explore: {
    label: 'Explore',
    items: [
      { label: 'Contact', href: '/contact' }
    ]
  }
};

export const offerings = [
  {
    title: 'End-to-end campaign management',
    image: 'https://images.unsplash.com/photo-1531058020387-3be344556be6?w=1200&q=80',
    body: [
      'Traditional marketing is old news.',
      'The action is on social. We turn creative briefs into high-impact campaigns. Nasu Group is built to manage the whole process \u2014 from bespoke strategies to hands-on execution.',
      'This is the place for real influence. Where your brand gets a voice to build a community and pull maximum ROI from social. There\u2019s a reason the world\u2019s biggest brands and agencies choose us. See it for yourself.'
    ],
    cta: { label: 'View Our Work', href: '/#work' }
  },
  {
    title: '360\u00b0 Talent Management',
    image: 'https://images.unsplash.com/photo-1496440737103-cd596325d314?w=1200&q=80',
    body: [
      'Do what you love, full-time.',
      'We make it happen through dedicated support for every creator on our roster. That includes day-to-day management, access to brands, content strategy, financial advice, mental health support, and strategic career progression. Plus, the doors to our free London-based studio are always open to you.',
      'We also relieve the admin pressures that have you backed into a corner. You\u2019re free to create content. We\u2019ll keep shit running in the background.'
    ],
    cta: { label: 'View Our Talent', href: '/contact' }
  },
  {
    title: 'Connecting brands with social-first creators',
    image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=1200&q=80',
    body: [
      'The wrong partnerships can kill even the greatest brands. Authentic connections are where it\u2019s at. We exclusively manage 150+ social-first creators, with a roster spanning fashion, beauty, comedy, lifestyle, family, sports, travel and more.',
      'We merge the world\u2019s biggest brands and agencies with top, trusted creators in your niche. Trust is your best sales tool, so let\u2019s lean into that.',
      'Every brand and creator gets access to a full team of managers. Expect fast reactions and a getting-shit-done attitude. The social landscape doesn\u2019t sit still and neither do we.'
    ],
    cta: { label: 'Enquire Now', href: '/enquiry' }
  }
];


export const aboutHeroImages = [
  'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&q=80',
  'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=600&q=80',
  'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=600&q=80',
  'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=600&q=80',
  'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=600&q=80',
  'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=600&q=80',
  'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=600&q=80',
  'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=600&q=80',
  'https://images.unsplash.com/photo-1521119989659-a83eee488004?w=600&q=80',
  'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=600&q=80',
  'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=600&q=80',
  'https://images.unsplash.com/photo-1463453091185-61582044d556?w=600&q=80'
];

export const stats = [
  { label: 'Talent Roster', value: '160+', body: "We represent over 160 of the world\u2019s most relevant social-first content creators." },
  { label: 'Monthly Views', value: '3.3B', body: 'Our talent roster amasses 3.3 billion monthly views across all social platforms.' },
  { label: 'Brand Campaigns', value: '5000+', body: "Since 2020, we\u2019ve successfully run over 5000 campaigns for brands and agencies." },
  { label: 'Brands & Clients', value: '1000+', body: "We\u2019ve worked with over 1000 brands, including Amazon, Google, and Netflix." }
];

export const awards = [
  { name: 'Campaign \u2014 Best Places to Work 2025', tag: 'Campaign' },
  { name: 'Culture 100 \u2014 Both UK and USA\u2019s Greatest Companies to Work For', tag: 'Culture 100' },
  { name: 'Campaign \u2014 Best Places to Work 2025', tag: 'Campaign' },
  { name: 'Culture 100 \u2014 Both UK and USA\u2019s Greatest Companies to Work For', tag: 'Culture 100' },
  { name: 'The Drum \u2014 Agency of the Year 2024', tag: 'The Drum' },
  { name: 'Campaign \u2014 Best Places to Work 2025', tag: 'Campaign' },
  { name: 'Culture 100 \u2014 Both UK and USA\u2019s Greatest Companies to Work For', tag: 'Culture 100' }
];

export const whatWeDo = [
  {
    title: 'Serving success for social-first talent',
    image: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=1200&q=80',
    body: [
      'Design a future around your passion. We\u2019re a full-service talent management and micro-influencer agency providing support for creators and micro-creators to earn a living off the back of their own brilliance.',
      'From personalised management to brand partnerships, content strategy and career development, you get a driven, agile team supporting your growth. We\u2019ve helped our creators get life-changing gigs with brands like Disney, ASOS, Sony, Paramount, L\u2019Oreal and more.',
      'We know all about the struggles on the way to the top, too. So we offer mental health and financial support, and operate an \u201calways-open\u201d door policy.'
    ],
    cta: { label: 'View our talent', href: '/contact' }
  },
  {
    title: 'Giving brands the tools to amplify it all',
    image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=1200&q=80',
    body: [
      'Forget what you know about marketing. Today, brands grow at the core of creator culture and we\u2019re exploiting that. In a big way.',
      'At Nasu Group, we craft game-changing, social-first strategies and scroll-stopping content. We began as a talent agency, so we\u2019ve got unmatched insights into what works \u2014 to shape our strategies and keep your brands ahead of the curve.',
      'With a diverse roster of talent \u2014 from athletes to comedians and beyond \u2014 we\u2019ve got a creator for almost every brief. So, whatever your goals, we\u2019ve got every angle covered. Just call us your all-in-one social powerhouse.'
    ],
    cta: { label: 'View our work', href: '/#work' }
  }
];

export const team = [
  {
    name: 'Benjy Leslie',
    role: 'Founder & CEO',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=900&q=80',
    linkedin: '#'
  },
  {
    name: 'Ben Rosen',
    role: 'Head of Talent',
    image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=900&q=80',
    linkedin: '#'
  },
  {
    name: 'Jordan Levy',
    role: 'Business Development Director',
    image: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?w=900&q=80',
    linkedin: '#'
  },
  {
    name: 'Josh Saffer',
    role: 'Head of New Business',
    image: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=900&q=80',
    linkedin: '#'
  },
  {
    name: 'Elisha Kramer',
    role: 'Brand & Talent Director',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=900&q=80',
    linkedin: '#'
  },
  {
    name: 'Oliver Segall',
    role: 'Business Director',
    image: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=900&q=80',
    linkedin: '#'
  }
];
